import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { useParams } from 'react-router-dom';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import jsPDF from 'jspdf';  // Library to generate PDF
import 'jspdf-autotable';  // Plugin for auto table
import generateReturnPDF from './generateReturnPDF';
import '../common/commonStyles.css';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from 'minimal-ui';

const ReturnListPrint = (props) => {

	const { orderId } = useParams();
	const [shopDetails, setShopDetails] = useState([]);
	const [orderDetails, setOrderDetails] = useState([]);
	const [productDetails, setProductDetails] = useState([]);
	const [totalVal, setTotalVal] = useState({
		totalstd: 0,
		totalzeroGoods: 0,
		totalTax: 0,
		orderDiscount: 0,
		over_all_discount: 0,
		over_all_amount: 0,
		grandTotal: 0,
	});
	const accessToken = localStorage.getItem('accessToken');
	const currencySymbol = localStorage.getItem('currencySymbol') || '£';
	const company_tax_type = localStorage.getItem('company_tax_type');
	const formatCurrency = (value) => `${currencySymbol}${parseFloat(value || 0).toFixed(2)}`;


	const fetchInvoice = async () => {
		const formData = new FormData();
		formData.append('id', orderId);
		const apiUrl = `${config.API_URL}/return/returnView`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch Not Order Report');
			}
			const data = await response.json();
			//console.log(data.details.shop_details);
			setShopDetails(data.data.shop_details);
			setOrderDetails(data.data.commonData);
			setProductDetails(data.data.itemData);

			const items = data.data.itemData || [];
			const common = data.data.commonData || {};
			let totalStdGoods = 0;
			let totalZeroGoods = 0;
			let vatAmount = 0;
			items.forEach((product) => {
				const subtotal = parseFloat(product.subtotal || 0);
				const tax = parseFloat(product.tax || product.item_tax || 0);
				const taxPercent = parseFloat(product.tax_rate_percent || 0);
				const isZeroRated = taxPercent === 0 && (product.tax === '0.00' || product.tax === '0' || product.tax == null || product.tax === '');
				vatAmount += tax;
				if (isZeroRated) {
					totalZeroGoods += subtotal;
				} else {
					totalStdGoods += subtotal;
				}
			});
			const orderDiscount = parseFloat(common.over_all_amount || common.order_discount || 0);
			const over_all_discount = parseFloat(common.over_all_discount || 0);
			const over_all_amount = parseFloat(common.over_all_amount || 0);
			const grandTotal = parseFloat(common.grand_total || 0) > 0
				? parseFloat(common.grand_total)
				: totalStdGoods + vatAmount + totalZeroGoods - over_all_amount;
			setTotalVal({
				totalstd: totalStdGoods,
				totalzeroGoods: totalZeroGoods,
				totalTax: vatAmount,
				orderDiscount,
				over_all_discount,
				over_all_amount,
				grandTotal,
			});


		} catch (error) {
		}
	};


	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		const isRhp =
			config.PREFIX === "rhp" ||
			accessToken === "rhp" ||
			accessToken === "hp";
		if (isRhp) {
			window.location.href = `${config.BASE_URL}/returns/view_rhp/${orderId}`;
			return;
		}
		fetchInvoice();
	}, []);

	useEffect(() => {
		const table = $('#invoicePrint').DataTable({
			pageLength: 50,
			paging: false,
			lengthMenu: [10, 20, 50],
			searching: false,
			ordering: false,
			info: false,
			responsive: true,
			autoWidth: false,
			data: productDetails,
			columns: [
				{
					data: null,
					render: function (data, type, row) {
						return `<span>${row.product_code} - ${row.product_name}</span> `;
					}
				},
				{
					data: null, className: 'text-center',
					render: function (data, type, row) {
						return `<span>${parseInt(row.quantity)}</span>`;
					}
				},
				{
					data: null, className: 'text-center',
					render: function (data, type, row) {
						return `<span>${row.return_type}</span>`;
					}
				},
				{
					data: 'unit_price',
					className: 'text-center',
					render: function (data, type, row) {
						return row.unit_price ? `<span>${currencySymbol} ${parseFloat(row.unit_price).toFixed(2)}</span>` : `<span>£ 0.00</span>`;
					}
				},
				{
					data: 'item_tax',
					className: 'text-center',
					render: function (data, type, row) {
						return row.tax ? `<span>${row.tax}</span>` : `<span>0.00</span>`;
					}
				},
				{
					data: 'subtotal',
					className: 'text-center',
					render: function (data, type, row) {
						return row.subtotal ? `<span>${currencySymbol} ${parseFloat(row.subtotal).toFixed(2)}</span>` : `<span>£ 0.00</span>`;
					}
				},

			],
			columnDefs: [
				{
					targets: [0],
					orderable: false
				}
			],
			drawCallback: function (settings) {
				var api = this.api();

				$('tfoot').empty();

				// Create footer rows with totals
				const footerRows = [
					{
						colSpan: 5,
						label: 'Total VAT Goods',
						value: `${currencySymbol} ${totalVal.totalstd.toFixed(2)}`
					},
					{
						colSpan: 5,
						label: `${company_tax_type} Amount`,
						value: `${currencySymbol} ${totalVal.totalTax.toFixed(2)}`
					},
					{
						colSpan: 5,
						label: 'Total Zero VAT Goods',
						value: `${currencySymbol} ${totalVal.totalzeroGoods.toFixed(2)}`
					},
					{
						colSpan: 5,
						label: 'Invoice Total',
						value: `${currencySymbol} ${totalVal.grandTotal.toFixed(2)}`
					}
				];

				// Append rows to the footer
				footerRows.forEach(row => {
					const footerRow = $('<tr>')
						.append(`<td colSpan="${row.colSpan}"><span class="right">${row.label}</span></td>`)
						.append(`<td><span>${row.value}</span></td>`);
					$('tfoot').append(footerRow);
				});
			}
		});
		return () => {
			table.destroy();
		};
	}, [productDetails, totalVal]);





	const handleGenerateDeliveryNotePDF = (e, orderId) => {
		generateReturnPDF(orderId);
	}

	return (
		<>
			<Box className="page-container">
				<Paper className="paper-style">

					{/* Print Button */}
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, m: 2 }}>
						<Button
							variant="contained"
							className="button-variant-contained"
							onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}
						>
							Print
						</Button>
					</Box>

					{/* Main Content */}
					<Box sx={{ mt: 2 }}>
						<Box>
							<Box>
								{/* Shop Details */}
								<Box
									className="row"
									sx={{ pb: 2, borderBottom: '1px solid #ccc' }}
								>
									<Box className="col-7">
										<Typography display="flex" flexDirection="column">
											<Typography variant="body2" fontWeight={500}> {shopDetails?.shop_name}</Typography>
											<Typography variant="body2" fontWeight={500}> TEL :{shopDetails?.phone}</Typography>
											<Typography variant="body2" fontWeight={500}>{company_tax_type} NO:</Typography>
											<Typography variant="body2" fontWeight={500}>
												COMPANY REG NO : {shopDetails?.company_reg_no}
											</Typography>
										</Typography>
									</Box>

									<Box className="col-5">
										<Box sx={{ pl: 2, m: 0 }} display="flex" flexDirection="column">

											<Typography variant="body2" fontWeight={500}>PLEASE PHONE THE OFFICE TO
												PAY BY CREDIT/DEBIT CARD
											</Typography>
											<Typography display="flex" flexDirection="row" gap={1}>
												<Typography variant="body2" fontWeight={500}>Bank A/C :</Typography> <Typography variant="body2" fontWeight={500}>{shopDetails?.bank_ac}</Typography>
											</Typography>
											<Typography display="flex" flexDirection="row" gap={1}>
												<Typography variant="body2" fontWeight={500}>Sort Code :</Typography> <Typography variant="body2" fontWeight={500}>{shopDetails?.sort_code}</Typography>
											</Typography>
										</Box>
									</Box>
								</Box>

								{/* Customer Details */}
								<Box className="row" sx={{ pt: 2 }}>
									<Box className="col-7">
										<Typography>
											<Typography variant="body2" fontWeight={500}>{orderDetails?.company}</Typography>
											<Typography variant="body2" fontWeight={500}>{orderDetails?.address}</Typography>
											<Typography variant="body2" fontWeight={500}>{orderDetails?.city}, {orderDetails?.postal_code},{' '}
												{orderDetails?.country}</Typography>
										</Typography>
									</Box>

									<Box className="col-5">
										<Box display="flex" flexDirection="column" >
											<Typography display="flex" flexDirection="row" gap={1}>
												<Typography variant="body2" fontWeight={500} >Credit Note No:</Typography> <Typography variant="body2" fontWeight={500}>INV
													{orderDetails?.reference_no}</Typography>
											</Typography>
											<Typography display="flex" flexDirection="row" gap={1}>
												<Typography variant="body2" fontWeight={500} >Credit Date:</Typography> <Typography variant="body2" fontWeight={500}>{orderDetails?.date}</Typography>
											</Typography>
											<Typography display="flex" flexDirection="row" gap={1}>
												<Typography variant="body2" fontWeight={500} >Cust Account No:</Typography>{' '}
												<Typography variant="body2" fontWeight={500}>{orderDetails?.reference_no}</Typography>
											</Typography>
										</Box>
									</Box>
								</Box>

								{/* Table */}
								<TableContainer sx={{ mt: 3 }}>
									<Table className="table-cell-border" sx={{ tableLayout: "fixed", width: "100%" }}>
										<TableHead className="table-cell-header">
											<TableRow>
												<TableCell sx={{ width: "40%" }}>Description</TableCell>
												<TableCell sx={{ width: "12%" }} align="center">Quantity</TableCell>
												<TableCell sx={{ width: "12%" }} align="center">Type</TableCell>
												<TableCell sx={{ width: "12%" }} align="right">Unit Price</TableCell>
												<TableCell sx={{ width: "12%" }} align="right">{company_tax_type} Amount</TableCell>
												<TableCell sx={{ width: "12%", minWidth: 100 }} align="right">Net Amount</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{productDetails?.map((item, index) => (
												<TableRow key={index}>
													<TableCell sx={{ width: "40%" }}>
														{item.product_code} - {item.product_name}
													</TableCell>
													<TableCell sx={{ width: "12%" }} align="center">{item.quantity}</TableCell>
													<TableCell sx={{ width: "12%" }} align="center">{item.return_type}</TableCell>
													<TableCell sx={{ width: "12%" }} align="right">{formatCurrency(item.unit_price)}</TableCell>
													<TableCell sx={{ width: "12%" }} align="right">{formatCurrency(item.tax)}</TableCell>
													<TableCell sx={{ width: "12%", minWidth: 100 }} align="right">{formatCurrency(item.subtotal)}</TableCell>
												</TableRow>
											))}
										</TableBody>

										<TableFooter>
											<TableRow className="innvoice-summary-align">
												<TableCell className="innvoice-summary-title" colSpan={5} align="right" >
													Total VAT Goods
												</TableCell>
												<TableCell className="innvoice-summary-value" >
													{formatCurrency(totalVal.totalstd)}
												</TableCell>
											</TableRow>
											<TableRow className="innvoice-summary-align">
												<TableCell className="innvoice-summary-title" colSpan={5} align="right" >
													VAT Amount
												</TableCell>
												<TableCell className="innvoice-summary-value" >
													{formatCurrency(totalVal.totalTax)}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell className="innvoice-summary-title" colSpan={5} align="right" >
													Total Zero VAT Goods
												</TableCell>
												<TableCell className="innvoice-summary-value" >
													{formatCurrency(totalVal.totalzeroGoods)}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell className="innvoice-summary-title" colSpan={5} align="right" >
													Order Discount
												</TableCell>
												<TableCell className="innvoice-summary-value" >
													{formatCurrency(totalVal.over_all_amount || totalVal.orderDiscount)}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell className="innvoice-summary-title" colSpan={5} align="right" >
													Total Amount
												</TableCell>
												<TableCell className="innvoice-summary-value" >
													{formatCurrency(totalVal.grandTotal)}
												</TableCell>
											</TableRow>
										</TableFooter>

									</Table>
								</TableContainer>

								{(orderDetails?.note ||
									orderDetails?.return_note ||
									orderDetails?.staff_note) && (
									<Box sx={{ mt: 2, px: 0.5 }}>
										<Typography variant="body2" fontWeight={600}>
											Note:
										</Typography>
										<Typography variant="body2" fontWeight={500} sx={{ mt: 0.5 }}>
											{orderDetails?.note ||
												orderDetails?.return_note ||
												orderDetails?.staff_note}
										</Typography>
									</Box>
								)}

								{/* Footer Note */}
								<Typography  className="invoice-footer-text">
									No claims for damages or short delivery will be considered
									unless made at the time of delivery of goods. These goods are
									not sold on a sale or return basis.
								</Typography>

							</Box>
						</Box>
					</Box>

				</Paper>
			</Box>
		</>
	);
}

export default ReturnListPrint;
